export default "__VITE_ASSET__73bfab5b__"